import React, { FC } from 'react';

import Link from 'next/link';

import { useQuery } from 'react-query';

import { useInterviewArticles } from '@hooks_iqfu/dashboard/useInterviewArticles';

import styles from './InterviewArticles.module.scss';

type Props = {
  companyId: string;
};

const InterviewArticles: FC<Props> = ({ companyId }: Props) => {
  const { getCompanyInterviewArticles } = useInterviewArticles();

  const { data: interviewArticles } = useQuery(
    ['companyInterviewArticles', companyId],
    () => getCompanyInterviewArticles(Number(companyId)),
    { staleTime: 600 },
  );

  return (
    <div className={styles.interview_articles_container}>
      <div className={styles.section_title_wrap}>
        <h3 className={styles.contents_title}>インタビュー記事一覧</h3>
        <Link href={`/console/admin/company/${companyId}/interview_articles/create`} passHref>
          <a className={styles.add_button}>新規登録</a>
        </Link>
      </div>
      <div>
        {interviewArticles?.map((article) => (
          <div key={article.id} className={styles.interview_articles_wrap}>
            <div className={styles.flex}>
              <div className={`${styles.is_public} ${article.is_public ? styles.is_public : styles.is_private}`}>
                {article.is_public ? '公開' : '非公開'}
              </div>
              <div className={styles.article_info}>{article.title || '（タイトル未設定）'}</div>
            </div>
            <Link href={`/console/admin/company/${companyId}/interview_articles/${article.id}/edit`} passHref>
              <a className={styles.edit_button}>編集</a>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InterviewArticles;
